import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'

export interface LoadProductRawMaterialsQuery {
  especif1: string
  quantity: number
  currentDate: string
}

export interface RawMaterial {
  productId: string
  description?: string
  configuration?: string
  quantityNeeded?: number
  stock?: number
  unityMeasure?: string
  [key: string]: any
}

type Response = {
  data: RawMaterial[]
}

const loadProductRawMaterials = (
  productId: string,
  query: LoadProductRawMaterialsQuery
): Promise<Response> => {
  return axios.get(`/orders/products/${productId}/raw-materials`, {
    params: query
  })
}

export function useLoadProductRawMaterials(
  productId: string,
  query: LoadProductRawMaterialsQuery,
  enabled = true
) {
  return useQuery(
    ['productRawMaterials', productId, query],
    () => loadProductRawMaterials(productId, query),
    {
      enabled:
        enabled &&
        !!productId &&
        !!query.especif1 &&
        !!query.quantity &&
        !!query.currentDate,
      onError: () =>
        toast.error('Não foi possível carregar as matérias primas!', {
          toastId: 'loadProductRawMaterials'
        })
    }
  )
}
